import HowReferralsWorkRevamp from './HowReferralsWorkRevamp';

export default HowReferralsWorkRevamp;
